<!-- Go to www.addthis.com/dashboard to customize your tools -->
<ng-container *ngIf="!follow">
    <a [attr.data-url]="url" [attr.data-title]="title" [attr.data-description]="description" [attr.data-media]="imageUrl" class="addthis_inline_share_toolbox"></a>
</ng-container>


<ng-container *ngIf="follow">
    <div class="addthis_inline_follow_toolbox"></div>
</ng-container>